/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots8VIcon24Regular = forwardRef('UiMenuDots8VIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M9.303 5.75a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" }),
        React.createElement("path", { d: "M9.303 11.168a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" }),
        React.createElement("path", { d: "M11.178 14.71a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Z" }),
        React.createElement("path", { d: "M9.303 22.003a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" }),
        React.createElement("path", { d: "M16.572 3.875a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Z" }),
        React.createElement("path", { d: "M14.678 11.168a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" }),
        React.createElement("path", { d: "M16.553 14.71a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Z" }),
        React.createElement("path", { d: "M14.678 22.003a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" })));
});
